import {
  formatRelative,
  formatDistance,
  formatDistanceToNow,
  format,
  parse,
  differenceInDays,
  parseISO,
  isEqual,
  isAfter,
  isBefore,
  differenceInMinutes,
} from 'date-fns';
import { th, enUS } from 'date-fns/locale';
import { StoreTimezoneKey } from '@/libs/constant';
import { isClient } from '@/utils/appUtil';

export const FORMAT_DATE = 'dd/MM/yyyy'; // 25/05/2022
export const FORMAT_DATETIME = 'dd/MM/yyyy HH:mm:ss'; // 25/05/2022 17:26:31
export const FORMAT_DATE1 = 'dd MMM yyyy'; // 25 JAn 2022
export const FORMAT_DATE2 = 'dd MMMM yyyy'; // 25 May 2022
export const FORMAT_DATE3 = 'E dd MMMM yyyy'; // Wed 25 May 2022
export const FORMAT_DATE4 = 'EEEE dd MMMM yyyy'; // Wednesday 25 May 2022
export const FORMAT_DATE5 = 'E dd MMM yyyy'; // Wed 25 Jan 2022
export const FORMAT_DATE6 = 'PPP'; // May 25th, 2022
export const FORMAT_DATE7 = 'PPPppp'; // May 25th, 2022 at 5:26:31 PM GMT+7
export const FORMAT_DATE8 = 'E dd MMMM yyyy HH:mm:ss'; // Wed 25 May 2022 17:26:31
export const FORMAT_DATE9 = 'dd MMMM yyyy HH:mm:ss'; // 25 May 2022 17:26:31
export const FORMAT_DATE10 = 'yyyy/MM/dd'; // 2022/05/25
export const FORMAT_DATE11 = 'PPPp'; // April 28th, 2022 at 11:30 AM
export const FORMAT_DATE12 = 'PPp'; // Apr 28, 2022, 11:30 AM
export const FORMAT_DATE13 = 'yyyy-MM-dd HH:mm:ss';
export const FORMAT_DATE14 = 'yyyy-MM-dd';
export const FORMAT_DATE15 = 'aaa'; // am, pm
export const FORMAT_DATE16 = 'dd/MM/yy'; // 25/05/22
export const FORMAT_DATE17 = 'dd/MM/yyyy HH:mm'; // 25/05/2022 17:26
export const FORMAT_DATE18 = 'HH:mm'; // 17:26
export const FORMAT_DATE19 = 'dd/MM'; // 25/05
export const FORMAT_DATE20 = 'dd/MM HH:mm'; // 25/05

export const addDateByDays = (days: number) => {
  const date = new Date();
  date.setDate(date.getDate() + days);
  return date;
};
export const addDateByDaysV2 = (d: Date, days: number) => {
  d.setDate(d.getDate() + days);
  return d;
};
export const getDateNow = () => {
  return new Date();
};
export const getYearNow = () => {
  return new Date().getFullYear();
};
export const getMonthNow = () => {
  return new Date().getMonth();
};
export const getCurrentTimestamp = () => {
  return Date.now();
};
export const getCurrentTime = () => {
  const now = new Date();
  const hours = String(now.getHours()).padStart(2, '0'); // Ensure two digits
  const minutes = String(now.getMinutes()).padStart(2, '0'); // Ensure two digits
  return `${hours}:${minutes}`;
};
export const getCurrentDateByFormat = (
  forMatString: string | undefined = FORMAT_DATE14, // yyyy-MM-dd
) => {
  return formatDateBy(getDateNow(), forMatString);
};
export const convertStringToDate = (
  dateString: string,
  format = 'yyyy-MM-dd HH:mm:ss',
): Date => {
  return parse(dateString, format, new Date());
  // return new Date(dateString);
};
export const convertDateFormatToThai = (dateString?: string | null) => {
  // convert YYYY-MM-DD to DD/MM/YYYY
  if (!dateString) {
    return undefined;
  }
  const parts = dateString.split('-');
  return parts[2] + '/' + parts[1] + '/' + parts[0];
};
export const convertThaiDateFormatToEng = (dateString?: string | null) => {
  // convert DD/MM/YYYY to YYYY-MM-DD
  if (!dateString) {
    return undefined;
  }
  const parts = dateString.split('/');
  return parts[2] + '-' + parts[1] + '-' + parts[0];
};

export const isDate2GreaterThan = (d1: Date, d2: Date) => {
  return d2.getTime() > d1.getTime();
};
export const isDate2GreaterOrEqualThanOnlyDate = (d1: Date, d2: Date) => {
  const tempDate2 = new Date(
    d2.getFullYear(),
    d2.getMonth(),
    d2.getDate(),
    0,
    0,
    0,
    0,
  );
  const tempDate1 = new Date(
    d1.getFullYear(),
    d1.getMonth(),
    d1.getDate(),
    0,
    0,
    0,
    0,
  );
  return tempDate2.getTime() >= tempDate1.getTime();
};
export const getDateDiff = (
  dateLeft: Date | number,
  dateRight: Date | number,
) => {
  return differenceInDays(dateRight, dateLeft);
};
export const getDateDiffNow = (dateString: string) => {
  const d = removeTime(dateString);
  const currentDate = removeTime(getCurrentDateByFormat());
  if (!d || !currentDate) {
    return 0;
  }
  // return getDateDiff(Date.parse(d), new Date());
  return getDateDiff(Date.parse(d), Date.parse(currentDate));
};

export const getDateAutoFormatBy = (
  dateString: string | undefined,
  locale: string = 'th',
) => {
  if (!dateString) {
    return '';
  }

  const difDays = getDateDiffNow(dateString);
  if (difDays > 0 && difDays < 365) {
    return formatDateTime(dateString, FORMAT_DATE19, locale);
  } else if (difDays > 365) {
    return formatDateTime(dateString, FORMAT_DATE16, locale);
  }
  return formatDateTime(dateString, FORMAT_DATE18, locale);
};
export const getDateTimeAutoFormatBy = (
  dateString: string | undefined,
  locale: string = 'th',
) => {
  if (!dateString) {
    return '';
  }
  const difDays = getDateDiffNow(dateString);
  if (difDays >= 0 && difDays < 1) {
    return formatDateTime(dateString, FORMAT_DATE18, locale);
  } else if (difDays >= 1 && difDays < 365) {
    return formatDateTime(dateString, FORMAT_DATE20, locale);
  } else {
    return formatDateTime(dateString, FORMAT_DATE17, locale);
  }
};
export const getDateDistanceAutoFormatBy = (
  dateString: string | undefined,
  locale: string = 'th',
) => {
  if (!dateString) {
    return '';
  }
  const difDays = getDateDiffNow(dateString);
  if (difDays >= 0 && difDays < 1) {
    return formatDistanceFromNow(dateString, locale);
  } else if (difDays >= 1 && difDays < 365) {
    return formatDateTime(dateString, FORMAT_DATE20, locale);
  } else {
    return formatDateTime(dateString, FORMAT_DATE17, locale);
  }
};

/**
 * formatRelativeFromNow('2022-05-25 17:26:31', locale.value)
 * @param dateString
 * @param locale
 * @returns
 */
export const formatRelativeFromNow = (
  dateString: string | undefined,
  locale: string = 'th',
) => {
  if (!dateString) {
    return;
  }
  return formatRelative(Date.parse(dateString), new Date(), {
    locale: locale == 'th' ? th : enUS,
  });
};
/**
 * formatDistanceFromNow('2022-05-25 17:26:31', locale.value)
 * @param dateString
 * @param locale
 * @param suffix
 * @returns
 */
export const formatDistanceFromNow = (
  dateString: string,
  locale: string | unknown,
  suffix: boolean = false,
) => {
  return formatDistanceToNow(convertStringToDate(dateString), {
    locale: locale == 'th' ? th : enUS,
    addSuffix: suffix,
  });
};
export const formatDistanceFrom = (
  dateString: string,
  fromDateString: string | undefined,
  locale: string | unknown,
) => {
  return formatDistance(
    convertStringToDate(dateString),
    fromDateString ? convertStringToDate(fromDateString) : new Date(),
    {
      locale: locale == 'th' ? th : enUS,
      addSuffix: true,
    },
  );
};
export const removeTime = (datetimeString: string) => {
  return datetimeString ? datetimeString.split(' ')[0] : '';
};
/**
 * formatDate('2022-05-25 17:26:31', 'dd MMMM yyyy', locale.value)
 * @param dateString
 * @param forMatString
 * @param locale
 * @returns
 */
export const formatDateTime = (
  dateString: string,
  forMatString: string,
  locale: string | unknown,
) => {
  return format(convertStringToDate(dateString), forMatString, {
    locale: locale == 'th' ? th : enUS,
  });
};
/**
 *
 * @param dateLeft the later date
 * @param dateRight the earlier date
 * @returns
 */
export const getDateDiffMinutes = (
  dateLeft: Date | number,
  dateRight: Date | number,
) => {
  return differenceInMinutes(dateRight, dateLeft);
};
export const formatDate = (
  dateString: string | undefined,
  forMatString: string,
  locale: string | unknown,
) => {
  if (!dateString) {
    return undefined;
  }
  const d = removeTime(dateString);
  return d
    ? format(convertStringToDate(d, FORMAT_DATE14), forMatString, {
      locale: locale == 'th' ? th : enUS,
    })
    : undefined;
};
export const formatDateBy = (d: Date, forMatString: string) => {
  return format(d, forMatString);
};
export const formatIos = (d: string, forMatString: string) => {
  return format(parseISO(d), forMatString);
};

export const isDateEqua = (dateLeft: string, dateRight: string) => {
  const d1 = convertStringToDate(dateLeft, FORMAT_DATE14);
  const d2 = convertStringToDate(dateRight, FORMAT_DATE14);
  return isEqual(d1, d2);
};
export const isDateAfter = (dateLeft: string, dateRight: string) => {
  const d1 = convertStringToDate(dateLeft, FORMAT_DATE14);
  const d2 = convertStringToDate(dateRight, FORMAT_DATE14);
  return isAfter(d1, d2);
};
export const isDateBefore = (dateLeft: string, dateRight: string) => {
  const d1 = convertStringToDate(dateLeft, FORMAT_DATE14);
  const d2 = convertStringToDate(dateRight, FORMAT_DATE14);
  return isBefore(d1, d2);
};

/**
 * Get timezone from localStorage
 * @returns Timezone string, defaults to 'UTC' if not found
 */
export const getTimezoneFromStorage = (): string => {
  if (!isClient()) {
    return 'UTC';
  }
  return localStorage.getItem(StoreTimezoneKey) || 'UTC';
};

export const getCurrentDateWithStoreTimezone = (timezone?: string): string => {
  const storeTimezone = timezone || getTimezoneFromStorage();
  const now = new Date();

  try {
    const formatter = new Intl.DateTimeFormat('en-CA', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      timeZone: storeTimezone,
    });

    return formatter.format(now);
  } catch (error) {
    console.error('Error getting current date with store timezone:', error);
    return getCurrentDateByFormat(FORMAT_DATE14);
  }
};

/**
 * Format date/time according to timezone stored in localStorage
 * Formats as: HH:mm dd/MM/yyyy (e.g., "14:30 25/12/2023")
 * @param dateString - ISO date string or Date object
 * @param timezone - Optional timezone override, if not provided will read from localStorage
 * @param includeSeconds - Optional, include seconds in format (default: false)
 * @returns Formatted date string in format HH:mm dd/MM/yyyy or HH:mm:ss dd/MM/yyyy
 */
export const formatDateTimeWithStoreTimezone = (
  dateString: string | Date | undefined,
  timezone?: string,
  includeSeconds: boolean = false,
): string => {
  if (!dateString) {
    return '';
  }

  try {
    const storeTimezone = getTimezoneFromStorage() || 'UTC';
    const date = typeof dateString === 'string' ? new Date(dateString) : dateString;

    const timeFormatter = new Intl.DateTimeFormat('en-GB', {
      hour: '2-digit',
      minute: '2-digit',
      ...(includeSeconds && { second: '2-digit' }),
      timeZone: storeTimezone,
      hour12: false,
    });

    const dateFormatter = new Intl.DateTimeFormat('en-GB', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      timeZone: storeTimezone,
    });

    const timeStr = timeFormatter.format(date);
    const dateStr = dateFormatter.format(date);

    // Format: HH:mm dd/MM/yyyy or HH:mm:ss dd/MM/yyyy
    return `${timeStr} ${dateStr}`;
  } catch (error) {
    console.error('Error formatting date with store timezone:', error);
    // Fallback to default format
    const date = typeof dateString === 'string' ? new Date(dateString) : dateString;
    const timeStr = date.toLocaleTimeString('en-GB', { hour12: false, hour: '2-digit', minute: '2-digit' });
    const dateStr = date.toLocaleDateString('en-GB');
    return `${timeStr} ${dateStr}`;
  }
};

/**
 * Format date only (without time) according to timezone stored in localStorage
 * Formats as: dd/MM/yyyy (e.g., "25/12/2023")
 * @param dateString - ISO date string or Date object
 * @param timezone - Optional timezone override, if not provided will read from localStorage
 * @returns Formatted date string in format dd/MM/yyyy
 */
export const formatDateWithStoreTimezone = (
  dateString: string | Date | undefined,
  timezone?: string,
): string => {
  if (!dateString) {
    return '';
  }

  try {
    const storeTimezone = timezone || getTimezoneFromStorage();
    const date = typeof dateString === 'string' ? new Date(dateString) : dateString;

    const formatter = new Intl.DateTimeFormat('en-GB', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      timeZone: storeTimezone,
    });

    return formatter.format(date);
  } catch (error) {
    console.error('Error formatting date with store timezone:', error);
    return formatDate(
      typeof dateString === 'string' ? dateString : dateString.toISOString(),
      FORMAT_DATE,
      'en',
    ) || '';
  }
};

/**
 * Format time only (HH:mm:ss) according to timezone stored in localStorage
 * @param dateString - ISO date string or Date object
 * @param timezone - Optional timezone override, if not provided will read from localStorage
 * @returns Formatted time string in format HH:mm:ss
 */
export const formatTimeWithStoreTimezone = (
  dateString: string | Date | undefined,
  timezone?: string,
): string => {
  if (!dateString) {
    return '';
  }

  try {
    const storeTimezone = timezone || getTimezoneFromStorage();
    const date = typeof dateString === 'string' ? new Date(dateString) : dateString;

    // Format: HH:mm:ss
    const formatter = new Intl.DateTimeFormat('en-GB', {
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      timeZone: storeTimezone,
      hour12: false,
    });

    return formatter.format(date);
  } catch (error) {
    console.error('Error formatting time with store timezone:', error);
    return formatDateTime(
      typeof dateString === 'string' ? dateString : dateString.toISOString(),
      FORMAT_DATE18,
      'en',
    );
  }
};


export function formatToDateString(
  dateInput: string | Date | number | null | undefined,
  timezone?: string,
): string {
  if (!dateInput) return '';

  try {
    const date = new Date(dateInput);
    const storeTimezone = timezone || getTimezoneFromStorage();
    const formatter = new Intl.DateTimeFormat('en-CA', {
      timeZone: storeTimezone,
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
    });

    const formatted = formatter.format(date);

    return formatted;
  } catch (err) {
    console.error('Invalid date input:', dateInput, err);
    return '';
  }
}

/**
 * @param timezone - Optional timezone override, if not provided will read from localStorage
 * @returns Day of week (0 = Sunday, 1 = Monday, ..., 6 = Saturday)
 */
export const getDayOfWeekWithStoreTimezone = (timezone?: string): string | undefined => {
  const storeTimezone = timezone || getTimezoneFromStorage();
  const now = new Date();

  try {
    const formatter = new Intl.DateTimeFormat('en-US', {
      weekday: 'long',
      timeZone: storeTimezone,
    });

    const dayName = formatter.format(now).toLowerCase();
    return dayName;
  } catch (error) {
    console.error('Error getting day of week with store timezone:', error);
  }
};
